"use client";
import { useEffect } from "react";

export default function ShowGoToTop() {
    useEffect(() => {
        window.addEventListener('scroll', function () {
            const position = window.pageYOffset;
            var element = document.getElementsByClassName("scroll-to-target");
            if (position > 100) element[0]?.classList.remove('d-none');
            if (position < 100) element[0]?.classList.add('d-none');
        });
    }, []);
    return true;
};

export const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};


export function MoveNewsSidebar() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const moveInnerSidebar = () => {
            const extra = document.querySelector(
                ".post-page-st1.news_detail_page .marge_with_news_detail"
            );
            const existing = document.querySelector(
                ".post-page-st1.news_detail_page .news_newsdetail .marge_news_detail_hear"
            );
            if (!extra || !existing) return false;
            if (existing.contains(extra)) return true;
            existing.appendChild(extra);
            extra.classList.remove("hide");
            existing.classList.remove("hide");
            return true;
        };
        moveInnerSidebar();
        let tries = 0;
        const retry = setInterval(() => {
            if (moveInnerSidebar() || tries++ > 15) {
                clearInterval(retry);
            }
        }, 100);
        return () => clearInterval(retry);
    }, []);
    return null;
}


export function MoveFooterSubscribeForm() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const moveInnerSidebar = () => {
            const extra = document.querySelector(
                "footer .subscribeForm.form_formframework"
            );
            const existing = document.querySelector(
                "footer .subscribeForm_move_hear"
            );
            if (!extra || !existing) return false;
            if (existing.contains(extra)) return true;
            existing.appendChild(extra);
            extra.classList.remove("hide");
            existing.classList.remove("hide");
            return true;
        };
        moveInnerSidebar();
        let tries = 0;
        const retry = setInterval(() => {
            if (moveInnerSidebar() || tries++ > 15) {
                clearInterval(retry);
            }
        }, 100);
        return () => clearInterval(retry);
    }, []);
    return null;
}

export function MoveContactUsForm() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const moveInnerSidebar = () => {
            const extra = document.querySelector(
                ".contactForm.form_formframework"
            );
            const existing = document.querySelector(
                ".contact-page-st1 .contact-form.contact-form_move_hear.col-lg-7 .row .col-lg-12"
            );
            if (!extra || !existing) return false;
            if (existing.contains(extra)) return true;
            existing.appendChild(extra);
            extra.classList.remove("hide");
            existing.classList.remove("hide");
            return true;
        };
        moveInnerSidebar();
        let tries = 0;
        const retry = setInterval(() => {
            if (moveInnerSidebar() || tries++ > 15) {
                clearInterval(retry);
            }
        }, 100);
        return () => clearInterval(retry);
    }, []);
    return null;
}

export function MoveJobApplicationForm() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const moveInnerSidebar = () => {
            const extra = document.querySelector(
                ".jobApplicationForm.form_formframework"
            );
            const existing = document.querySelector(
                ".career-page-st1 .contact-form.jobApplicationForm_move_hear"
            );
            if (!extra || !existing) return false;
            if (existing.contains(extra)) return true;
            existing.appendChild(extra);
            extra.classList.remove("hide");
            existing.classList.remove("hide");
            return true;
        };
        moveInnerSidebar();
        let tries = 0;
        const retry = setInterval(() => {
            if (moveInnerSidebar() || tries++ > 15) {
                clearInterval(retry);
            }
        }, 100);
        return () => clearInterval(retry);
    }, []);
    return null;
}